module.exports = __webpack_public_path__ + "static/github-fef67c15f1df213ae3d781b9ad11100a.png";